



































































































































































































































































































































































































































import Overview from "../parts/Lists/Overview.vue";
import Decisionofvacation from "../parts/Lists/Decisionofvacation.vue";
import ViewVacationSubmitted from "../parts/Lists/ViewVacationSubmitted.vue";
import AddNewVacation from "../parts/Adders/AddNewVacation.vue";
import { Component, Vue } from "vue-property-decorator";
import Login from "../views/Login.vue";
import PersonnelList from "../parts/Lists/PersonnelList.vue";
import AlarmList from "../parts/Lists/AlarmList.vue";
import AlarmReport from "../parts/Lists/AlarmReport.vue";
import Logout from "../components/Logout.vue";
import Welcome from "../parts/Welcome.vue";
import AddAlarm from "../parts/Adders/AddAlarm.vue";
import AddPersonnel from "../parts/Adders/AddPersonnel.vue";
import AddWorkOrder from "../parts/Adders/AddWorkOrder.vue";
import WorkOrderList from "../parts/Lists/WorkOrderList.vue";
import AddPPMnew from "../parts/Adders/AddPPMnew.vue";
import AddPPMyearly from "../parts/Adders/AddPPMyearly.vue";
import PPMList from "../parts/Lists/PPMList.vue";
import PPMList2 from "../parts/Lists/PPMList2.vue";
import ppmexport from "../parts/Lists/ppmexport.vue"
import PPMReports from "../parts/Lists/PPMReports.vue";
import DownloadWorkOrders from "../parts/Downloaders/DownloadWorkOrders.vue";
import DownloadWorkOrderDetails from "../parts/Downloaders/DownloadWorkOrderDetails.vue";
import AddProject from "../parts/Adders/AddProject.vue";
import WorkOrderBin from "../parts/Bins/WorkOrderBin.vue";
import ActivityList from "../parts/Lists/ActivityList.vue";
import ChangePassword from "../components/ChangePassword.vue";
import AddComponent from "../parts/Adders/AddComponent.vue";
import ComponentList from "../parts/Lists/ComponentList.vue";
import ComponentBin from "../parts/Bins/ComponentBin.vue";
import ShiftList from "../parts/Lists/ShiftList.vue";
import dashBoard from "../parts/Stats/dashBoard.vue";
import PPMBin from "../parts/Bins/PPMBin.vue";
import employeeOfTheMonth from "../parts/Stats/employeeOfTheMonth.vue";
import AddShift from "../parts/Adders/AddShift.vue";
import ShiftBin from "../parts/Bins/ShiftBin.vue";
import { alarm } from "../api/alarm/alarm";
import { personnel } from "../api/personnel/personnel";
import { activities } from "../api/activity/activities";
import { component } from "../api/component/component";
import AddSystemInformation from "../parts/Adders/AddSystemInformation.vue";
import SystemInformationList from "../parts/Lists/SystemInformationList.vue";
import AddInternalInformation from "../parts/Adders/AddInternalInformation.vue";
import InternalInformationList from "../parts/Lists/InternalInformationList.vue";
import SystemInformationBin from "../parts/Bins/SystemInformationBin.vue";
import InternalInformationBin from "../parts/Bins/InternalInformationBin.vue";
import AlarmBin from "../parts/Bins/AlarmBin.vue";
import DownloadVacation from "../parts/Downloaders/DownloadVacation.vue";
import DownloadVacation2 from "../parts/Downloaders/DownloadVacation2.vue";
import DownloadPPMReports from "../parts/Downloaders/DownloadPPMReports.vue";
import AddNewProject from "../parts/Adders/AddNewProject.vue"
import AddNewDuration from "../parts/Adders/AddNewDuration.vue"
import ViewEmployeesDurations from "../parts/Lists/ViewEmployeesDurations.vue"
import ViewProjectsSubmitted from "../parts/Lists/ViewProjectsSubmitted.vue"
import newProjectReports from "../parts/Lists/newProjectReports.vue"
import DownloadNPReports from "../parts/Downloaders/DownloadNPReports.vue";
@Component({
  components: {
    DownloadPPMReports,
    DownloadNPReports,
    DownloadVacation2,
    Overview,
    Decisionofvacation,
    DownloadVacation,
    ViewVacationSubmitted,
    AddNewVacation,
    Login,
    Welcome,
    PersonnelList,
    AlarmList,
    AlarmReport,
    Logout,
    AddAlarm,
    AddPersonnel,
    AddWorkOrder,
    WorkOrderList,
    AddPPMnew,
    AddPPMyearly,
    AddNewProject,
    AddNewDuration,
    ViewEmployeesDurations,
    ViewProjectsSubmitted,
    newProjectReports,
    PPMList,
    PPMList2,
    ppmexport,
    PPMReports,
    DownloadWorkOrders,
    DownloadWorkOrderDetails,
    AddProject,
    WorkOrderBin,
    ActivityList,
    ChangePassword,
    AddComponent,
    ComponentList,
    ComponentBin,
    PPMBin,
    employeeOfTheMonth,
    dashBoard,
    AddShift,
    ShiftList,
    ShiftBin,
    AddSystemInformation,
    SystemInformationList,
    AddInternalInformation,
    InternalInformationList,
    InternalInformationBin,
    SystemInformationBin,
    AlarmBin
  } as any
})
export default class MainMenu extends Vue {
  public componentname: string = "Welcome";
  public details: any = {};
  public userlevel: number = -1;
  public menuClass: string = "menuExtended";
  public currentTime: number = 60;
  public resetTime(){
    this.$store.dispatch("resetTime");
  }  
  public updateTime() {
    console.log("time");
    this.$store.dispatch("timerTick");
    this.currentTime = this.$store.getters.getRemainingTime;

    if (this.currentTime <= 10 * 60 * 1000 && this.currentTime > 0) {
      if (this.currentTime % (60 * 1000) == 0) {
        //popup 5leptou me warning message
        this.$notify({
          title: "Logout",
          message:
            Math.floor(this.currentTime / (1000 * 60)) -
            1 +
            " minutes remain, please relog.",
          type: "warning",
          duration: 60 * 1000
        });
      }
    }
    if (this.currentTime <= 0 && !this.$store.getters.getDialogSeen) {
      this.$store.dispatch("dialogSeen");
      //psofos me messagebox element
      this.$alert("Press OK to Relog", "Login Expired", {
        confirmButtonText: "OK",
        callback: action => {
          this.$store.dispatch("resetTime");
          this.details = {};
          this.$store.dispatch("updateCurrentComponent", "Logout");
          this.componentname = "Logout";
        }
      });
    }
  }
  public async handleselection(key: string, key2: string) {
    switch (key) {
      case "cleanActivities":
        this.$message("Cleaning Activities");
        await activities.cleanActivities(
          this.$store.getters.getToken,
          this.$store.getters.getHost
        );
        this.$message.success("Activities Cleaned");
        break;
      case "cleanComponents":
        this.$message("Cleaning Components");
        await component.cleanComponents(
          this.$store.getters.getToken,
          this.$store.getters.getHost
        );
        this.$message.success("Components Cleaned");
        break;
      default:
        this.details = {};
        this.$store.dispatch("updateCurrentComponent", key);
        this.componentname = key;
        break;
    }
  }
  public mounted() {
    this.currentTime = this.$store.getters.getRemainingTime;
    this.details = this.$store.getters.getCurrentObject;
    this.componentname = this.$store.getters.getCurrentComponent;
    this.userlevel = this.$store.getters.getUserLevel;
    let timer = setInterval(this.updateTime, 1000);
  }
  public minimize() {
    this.menuClass = "menuMin";
  }
  public maximize() {
    this.menuClass = "menuExtended";
  }
}
